import BaseWidgetProvider from '../base/BaseWidgetProvider'
import { Card, Stack, Typography } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import TaskReferenceListWidget from './TaskReferenceListWidget'

const TaskReferenceWidgetPreview = (props) => {
  const { t_ } = useSmartTranslation()
  const tasks = [
    { uuid: '1', name: `${t_('Task 01')}` },
    { uuid: '2', name: `${t_('Task 02')}` },
    { uuid: '3', name: `${t_('Task 03')}` },
    { uuid: '4', name: `${t_('Task 04')}` }
  ]

  return (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        p: 1,
        color: '#F3F3F3',
        backgroundColor: '#1F1F1F',
        borderRadius: 2
      }}
    >
      {!tasks
        ? (
          <Stack sx={{ height: '100%' }} direction='row' spacing={1} alignItems='center' justifyContent='center'>
            <Typography color='primary'>{t_('There is no active job')}</Typography>
          </Stack>
          )
        : (
          <Stack sx={{ height: '100%', minHeight: 0 }}>
            <Stack spacing={1.75} sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
              {tasks.map(task => (
                <Stack
                  key={task.id}
                  direction='row'
                  alignItems='center'
                  spacing={1.25}
                  sx={{
                    px: 1,
                    py: 0.8,
                    borderRadius: 1.5,
                    border: '1px solid #2E2E2E',
                    backgroundColor: '#232323'
                  }}
                >
                  <Typography color='primary' sx={{ minWidth: 42, fontWeight: 700 }}>
                    {`${task.uuid}`}
                  </Typography>
                  <Typography
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {task.name}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>)}
    </Card>
  )
}

class TaskReferenceListWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'TaskReferenceWidgetProvider'

  getName = () => ('Task selector')

  getIcon = () => AssignmentOutlinedIcon

  createWidget = (props) => <TaskReferenceListWidget {...props} />

  createPreviewWidget = (props) => <TaskReferenceWidgetPreview {...props} />

  size = { defaultW: 2, defaultH: 4, minW: 2, minH: 4 }

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size) }
  }
}

export default TaskReferenceListWidgetProvider
